import {WorkflowStates} from './workflow-states';
import {StateMetadata} from './workflow.service';

// TODO DAS-383: store on backend and request on app start
export const STATE_METADATA: Record<WorkflowStates, StateMetadata> = {
  [WorkflowStates.NEED_IDENTIFIED]: {
    displayName: 'Need identified'
  },
  [WorkflowStates.SUBMISSION_IN_PREPARATION]: {
    displayName: 'Submission in preparation',
    timelineDisplayText: 'Submission in Preparation'
  },
  [WorkflowStates.PM_APPRAISAL]: {
    displayName: 'PM appraisal',
    timelineDisplayText: 'NH Project Manager Appraisal'
  },
  [WorkflowStates.PM_APPRAISAL_REWORK]: {
    displayName: 'PM appraisal rework',
    timelineDisplayText: 'Rework required from NH Project Manager'
  },
  [WorkflowStates.DAS_ADMIN]: {
    displayName: 'With DAS Admin',
    timelineDisplayText: 'DAS Admin Check'
  },
  [WorkflowStates.DAS_ADMIN_REWORK]: {
    displayName: 'Rework required from DAS Admin',
    timelineDisplayText: 'DAS Admin Rework'
  },
  [WorkflowStates.SPECIALIST_SUBMISSION_POINT]: {
    displayName: 'Specialist submission point',
    timelineDisplayText: 'Specialist Submission Point'
  },
  [WorkflowStates.SPECIALIST_SUBMISSION_POINT_REWORK]: {
    displayName: 'Specialist submission point rework',
    timelineDisplayText: 'Rework required by SSP'
  },
  [WorkflowStates.SPECIALIST_REVIEW]: {
    displayName: 'Specialist review',
    timelineDisplayText: 'Specialist Review'
  },
  [WorkflowStates.REWORK_REQUIRED]: {
    displayName: 'Rework required'
  },
  [WorkflowStates.PM_DETERMINATION]: {
    displayName: 'PM determination',
    timelineDisplayText: 'NH Project Manager Determination'
  },
  [WorkflowStates.APPROVED]: {
    displayName: 'Approved',
    timelineDisplayText: 'Determined'
  },
  [WorkflowStates.APPROVED_WITH_CONDITIONS]: {
    displayName: 'Approved with conditions'
  },
  [WorkflowStates.REJECTED]: {
    displayName: 'Rejected'
  },
  [WorkflowStates.WITHDRAWN]: {
    displayName: 'Withdrawn'
  }
};
